import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TitleBar from '../Layout/titleBar';
import MyDialog from '../Layout/myDialog';
import { Row, Col } from 'react-flexbox-grid';
import Item from './itemProveedor';
import { sagaGetProveedores } from '../../reducers/proveedoresReducer/actions';
import './proveedores.css';
import Pagination from '../Layout/pagination';

const ProveedorListado = (props) => {

    const [itemsProveedores, setItemsProveedores] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 24;

    React.useEffect(() => {
        const proveedores = Array.isArray(props.proveedores) ? props.proveedores: [];
        setItemsProveedores(proveedores.map((x) => ({
            idProveedor: x.idProveedor,
            nombreProveedor: x.nombreProveedor,
            codigo: x.codigo,
            opciones: props.mapToItem(x).opciones,
        })));
        setCurrentPage(1);
    }, [props.proveedores]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleSearch = (nombre) => {
        props.handleOnSearch(nombre);
        setCurrentPage(1);
    };

    // Elementos en página actual
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = itemsProveedores.slice(indexOfFirstItem, indexOfLastItem);

    return (
        <>
            <TitleBar
                title={'Proveedores'}
                handleOnSearch={handleSearch}
                searchPlaceholder="Proveedor"
                showSearch={true}
                newButtonLink='/Proveedores/Edit/0'
                validator="nombreynumeros"
            />

            <Row style={{ margin: '0px' }} className='draggable'>
                {currentItems && 
                    currentItems.map((item, index) => (
                        <Col md={6} lg={4} key={index} className='draggable'>
                            <Item item={item} {...props} />
                        </Col>
                    ))   
                }
            </Row>
            
            {(props.proveedores === undefined || props.proveedores.length === 0) && 
                <div className='noProveedores'>No se encontraron proveedores.</div>
            }

            {props.openModal &&
                <MyDialog
                    cuerpo={props.mensaje}
                    botonConfirmar={props.labelModalOk}
                    handleOnConfirmar={() => { props.handleModalOk(); setTimeout(props.handleOnSearch, 600); }}
                    handleOnCancelar={props.handleCloseModal}
                />
            }

            {/* Paginación */}
            { itemsProveedores.length > itemsPerPage &&
                <Pagination
                    handleOnChange={handlePageChange}
                    page={currentPage}
                    totalPages={Math.ceil(itemsProveedores.length / itemsPerPage)}
                />
            }
        </>
    );
};

ProveedorListado.propsTypes = {
    proveedores: PropTypes.array.isRequired,
    handleOnSearch: PropTypes.func.isRequired,
    openModal: PropTypes.bool,
    mensaje: PropTypes.string,
    labelModalOk: PropTypes.string,
    handleModalOk: PropTypes.func,
    handleCloseModal: PropTypes.func,
};

ProveedorListado.defaultProps = {
    proveedores: [],
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        sagaGetProveedores,
    }, dispatch);
};

export default connect(null, mapDispatchToProps)(ProveedorListado);